<script setup lang="ts">
// Stats tab: league top players grouped by category. When the league's leaders
// aren't wired yet, shows an honest empty state instead of erroring.
interface Leader {
  provider_player_id: string; name: string; team: string
  category: string; value: string
}
const props = defineProps<{ leaders: Leader[]; league: string }>()
const groups = computed(() => {
  const m: Record<string, Leader[]> = {}
  for (const l of props.leaders || []) (m[l.category] ||= []).push(l)
  return Object.entries(m).map(([category, items]) => ({ category, items }))
})
function playerLink(l: Leader) {
  return `/scoreboard/player/${encodeURIComponent(l.provider_player_id)}?league=${encodeURIComponent(props.league)}`
}
</script>

<template>
  <div class="stats">
    <div v-if="groups.length" class="grid">
      <div v-for="g in groups" :key="g.category" class="cat">
        <h3 class="ch">{{ g.category }}</h3>
        <NuxtLink v-for="(l, i) in g.items" :key="l.provider_player_id + i"
          :to="playerLink(l)" class="row">
          <span class="rank mono">{{ i + 1 }}</span>
          <span class="who"><span class="pn">{{ l.name }}</span><span class="tm">{{ l.team }}</span></span>
          <span class="val mono">{{ l.value }}</span>
        </NuxtLink>
      </div>
    </div>
    <p v-else class="empty">Player leaders aren't available for this league yet.</p>
  </div>
</template>

<style scoped>
.grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(260px, 1fr)); gap: 16px; }
.cat { border: 1px solid var(--line); border-radius: 12px; background: var(--panel); padding: 12px 14px; }
.ch { font-size: 12px; text-transform: uppercase; letter-spacing: 0.08em; color: var(--muted); margin-bottom: 8px; }
.row { display: flex; align-items: center; gap: 10px; padding: 7px 0; border-bottom: 1px solid rgba(53,42,96,0.5); }
.row:last-child { border-bottom: none; }
.rank { color: var(--muted); width: 18px; }
.who { display: flex; flex-direction: column; flex: 1; min-width: 0; }
.pn { font-weight: 600; }
.row:hover .pn { color: var(--accent); }
.tm { font-size: 11px; color: var(--muted); }
.val { font-weight: 700; color: var(--ink); }
.empty { color: var(--muted); text-align: center; padding: 28px 16px; }
</style>
